module.exports = __webpack_public_path__ + "static/media/hangar.66c18d7a.svg";